
import React from 'react';
import { Link } from 'react-router-dom';

const BestPractices: React.FC = () => {
  return (
    <>
      <div id="best-practices"></div>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Implementing these core best practices provides a foundation for secure document management in any CPA firm:
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Develop a Comprehensive Document Management Policy</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Start with a written policy that addresses document classification, retention periods, access controls, destruction procedures, and compliance requirements. This policy should be regularly reviewed, updated, and communicated to all staff. Our <Link to="/services/project-consulting" className="text-itmgmt-bright-blue hover:underline">project consulting team</Link> can help develop policies tailored to your firm's specific needs.
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Implement Robust Access Controls</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Establish role-based access controls (RBAC) that limit document access to only those who need it for their specific job functions. This should include:
      </p>
      <ul className="list-disc ml-8 mb-6 text-gray-700 leading-relaxed">
        <li>Multi-factor authentication for all system access</li>
        <li>Unique login credentials for each employee</li>
        <li>Regular access rights reviews and prompt revocation when employees change roles or leave</li>
        <li>Detailed access logs to track who has viewed, modified, or shared documents</li>
      </ul>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Encrypt Sensitive Data</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Implement encryption at multiple levels:
      </p>
      <ul className="list-disc ml-8 mb-6 text-gray-700 leading-relaxed">
        <li>At-rest encryption for stored documents</li>
        <li>In-transit encryption for documents being transferred or accessed</li>
        <li>Client portal encryption for securely sharing documents with clients</li>
        <li>Email encryption for any documents transmitted via email</li>
      </ul>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Establish Secure Client Collaboration Methods</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Implement secure client portals for document exchange rather than using email attachments. These portals should include secure authentication, encryption, and expiring access links for temporary document sharing. Learn how our <Link to="/services/cloud-solutions" className="text-itmgmt-bright-blue hover:underline">cloud solutions</Link> can provide secure client collaboration tools.
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Develop a Data Retention and Destruction Policy</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Create clear guidelines on how long different document types should be retained (following IRS and state requirements) and establish secure destruction protocols for both digital and physical documents when retention periods expire.
      </p>
    </>
  );
};

export default BestPractices;
